import React from 'react';
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import * as UiConfig from 'Flow2/components/CustomCollections/CustomDataConfig/CustomUiConfig';
import CustomEvents from 'Flow2/components/CustomCollections/CustomDataConfig/CustomAppEvents';
import { loadScriptsForApp } from "Flow2/components/CustomCollections/CustomDataControllers/CustomScriptsController";
import ShowGapi from "Flow2/components/CustomCollections/CustomDataControllers/CustomGapiController";
import { showTableMfInfo } from 'Flow2/components/CustomCollections/CustomBox/CustomTableBox/CustomTableBox';
import * as CustomForm from 'Flow2/components/CustomCollections/CustomDataControllers/CustomFormController';
import * as CustomMedia from 'Flow2/components/CustomCollections/CustomDataControllers/CustomMediaController';
import { checkGranting } from "Flow2/components/CustomCollections/CustomDataControllers/CustomGrantingController";
import { getUserData } from "Flow2/components/CustomCollections/CustomDataControllers/CustomUserController";
import { updateSearchObjects, changeSearchObjects } from "Flow2/components/CustomCollections/CustomDataControllers/CustomSearchController";
import { getSortOptionsForApp } from "Flow2/components/CustomCollections/CustomDataControllers/CustomSortController";
import CustomFlexController from 'Flow2/components/CustomCollections/CustomDataControllers/CustomFlexController';
import Auth from 'tdk/pages/AuthPage/AuthPage';

export const isPMDB = () => {
    if (process.env.REACT_APP_APPID === CustomTypes.APP_APPID_PMDB) return true;

    return false;
}

export const isPorscheArchiv = () => {
    if (process.env.REACT_APP_APPID === CustomTypes.APP_APPID_PORSCHEARCHIV) return true;

    return false;
}

export const isDZA = () => {
    if (process.env.REACT_APP_APPID === CustomTypes.APP_APPID_DZA) return true;

    return false;
}

export const isNLW = () => {
    if (process.env.REACT_APP_APPID === CustomTypes.APP_APPID_NLW) return true;

    return false;
}

export const isMaryTv = () => {
    if (process.env.REACT_APP_APPID === CustomTypes.APP_APPID_MARYTV) return true;

    return false;
}

export const isANT = () => {
    if (process.env.REACT_APP_APPID === CustomTypes.APP_APPID_ANT) return true;

    return false;
}

export const isERTU = () => {
    if (process.env.REACT_APP_APPID === CustomTypes.APP_APPID_ERTU) return true;

    return false;
}

export const isTranscoder1 = () => {
    if (process.env.REACT_APP_APPID === CustomTypes.APP_APPID_TRANSCODER1) return true;

    return false;
}

export const isOriginTranscoder1 = () => {
    if (window.location.origin == 'https://transcoder1.flowcenter.de') return true;
    if (window.location.orgin == 'http://localhost:3000'
        && process.env.REACT_APP_APPID === CustomTypes.APP_APPID_TRANSCODER1) {
        return true;
    }
    return false;
}

export const isQnap = () => {
    if (process.env.REACT_APP_APPID === CustomTypes.APP_APPID_QNAP) return true;
    return false;
}

export const isOkno = () => {
    if (process.env.REACT_APP_APPID === CustomTypes.APP_APPID_OKNO) return true;

    return false;
}

export const isFcpworks = () => {
    if (process.env.REACT_APP_APPID === CustomTypes.APP_APPID_FCPWORKS) return true;

    return false;
}

export const isStandardGroup = () => {
    if (process.env.REACT_APP_APPID === CustomTypes.APP_APPID_STANDARDGROUP) return true;

    return false;
}

export const isMotorvision = () => {
    if (process.env.REACT_APP_APPID === CustomTypes.APP_APPID_MOTORVISION) return true;

    return false;
}

export const isFrancetv = () => {
    if (process.env.REACT_APP_APPID === CustomTypes.APP_APPID_FRANCETV) return true;

    return false;
}

export const isSynology = () => {
    if (process.env.REACT_APP_APPID === CustomTypes.APP_APPID_SYNOLOGY) return true;

    return false;
}

export const isBetafilm = () => {
    if (process.env.REACT_APP_APPID === CustomTypes.APP_APPID_BETAFILM) return true;

    return false;
}

export const isVifogra = () => {
    if (process.env.REACT_APP_APPID === CustomTypes.APP_APPID_VIFOGRA) return true;

    return false;
}

export const isb47 = () => {
    if (process.env.REACT_APP_APPID === CustomTypes.APP_APPID_B47) return true;

    return false;
}

export const isSdk = () => {
    if (process.env.REACT_APP_APPID === CustomTypes.APP_APPID_SDK) return true;

    return false;
}

export const isTdk = () => {
    if (process.env.REACT_APP_APPID === CustomTypes.APP_APPID_TDK) return true;

    return false;
}

export const isSAPDemo = () => {
    if (process.env.REACT_APP_APPID === CustomTypes.APP_APPID_SAP_DEMO) return true;

    return false;
}

export const getInitStateForApp = (name) => {
    switch (name) {
        case "lang":
            if (isPMDB()) return "de";
            return "en";
        case "filter":
            if (isNLW()) return ["video", "pictures", "other", "audio"];
            if (isPorscheArchiv()) return ["video", "pictures", "other", "audio", "empty"];
            if (isPMDB()) return ["video", "pictures"];
            return ["video", "pictures", "other"];
    }
}

export const showGapiForApp = (props) => {
    if (UiConfig.showCustomAnalytics && isPMDB())
        return (<ShowGapi {...props} />)
}

export const CustomProvider = (props) => {
    return props.children;
}

export const initFlexController = () => {
    return (<CustomFlexController />);
}
export const CustomAppEventListener = (event, obj1 = null, obj2 = null, obj3 = null, obj4 = null) => {
    switch (event) {
        case CustomEvents.LOAD_SCRIPT:
            loadScriptsForApp(obj1, obj2);
            break;
        case CustomEvents.INIT_STATE:
            return getInitStateForApp(obj1);
        case CustomEvents.SHOW_GAPI:
            return showGapiForApp(obj1);
        case CustomEvents.INIT_FLEX_CONTROLLER:
            return initFlexController();
        case CustomEvents.CONVERT_METADATA:
            return CustomForm.convertMetaDataForClipInfo(obj1);
        case CustomEvents.GET_SORT_OPTION:
            return getSortOptionsForApp(obj1, obj2);
        case CustomEvents.GET_MF_DATA:
            return CustomMedia.getMfDataForApp(obj1, obj2);
        case CustomEvents.SHOW_MF_INFO:
            return showTableMfInfo(obj1, obj2);
        case CustomEvents.SETUP_DROPDOWN:
            return CustomForm.setupApiDataForDropDown(obj1, obj2, obj3);
        case CustomEvents.CHECK_GRANTING:
            return checkGranting(obj1, obj2);
        case CustomEvents.GET_USER_DATA:
            return getUserData(obj1);
        case CustomEvents.GET_FORM_TABS:
            return CustomForm.getFormTabs(obj1);
        case CustomEvents.UPDATE_SEARCH_OBJ:
            return updateSearchObjects(obj1, obj2, obj3);
        case CustomEvents.CHANGE_SEARCH_OBJ:
            return changeSearchObjects(obj1, obj2, obj3, obj4);
        case CustomEvents.GET_ICON:
            return CustomMedia.getIconForApp(obj1);
        case CustomEvents.GET_AWE_ICON:
            return CustomMedia.getFontAweIconForApp(obj1);
        case CustomEvents.GET_FONT_ICON:
            return CustomMedia.getFontIconForApp(obj1);
        case CustomEvents.CHANGE_FORM_STYLE:
            return CustomForm.changeFormStyleForApp(obj1);
        case CustomEvents.GET_FORM_COUNT:
            return CustomForm.getLeftCountForApp(obj1);
        default:
            break;

    }
}

const showAppErrorsDialog = ({ msg, formatMessage, authError, appInterval }) => {
    DataUtil.showConfirmDialogWithCallback(msg, formatMessage,
        () => {
            if (appInterval) clearInterval(appInterval);
            window.location.reload();
        }, true);
}

export const checkLogOutForApp = (authError = null, formatMessage) => {
    let isLoggedOut = false;
    if (!isLoggedOut) {
        window.flow.addEventListener(window.felib.main.event.LOGOUT, (event) => {
            console.log("LOGS: EVENT = LOGOUT", event);
            if (!isLoggedOut) {
                showAppErrorsDialog({ msg: 'logOutMsg', formatMessage, authError, appInterval });
                isLoggedOut = true;
            }
        });

        window.flow.addEventListener(window.felib.main.event.CLOSE, (event) => {
            console.log("LOGS: EVENT = CLOSE");
            if (!isLoggedOut) {
                showAppErrorsDialog({ msg: 'logOutMsg', formatMessage, authError, appInterval });
                isLoggedOut = true;
            }
        });

        let appInterval = setInterval(() => {
            if (!window.flow.socket || (window.flow.socket && window.flow.socket.readyState !== 1)) {
                if (!isLoggedOut) {
                    console.log("LOGS: WEBSOCKET CLOSED!");
                    showAppErrorsDialog({ msg: "lostConnectionMsg", formatMessage, authError, appInterval });
                    isLoggedOut = true;
                }
            }
        }, 1000);
    }
}

export const checkWebsocket = (authError = null, formatMessage) => {
    let isLoggedOut = false;
    console.log("CHECKLOGOUT");
    console.trace();
    if (!isLoggedOut) {
        window.flow.addEventListener(window.felib.main.event.LOGOUT, (event) => {
            console.log("LOGS: EVENT = LOGOUT", event);
            if (!isLoggedOut) {
                showAppErrorsDialog({ msg: 'logOutMsg', formatMessage, authError, appInterval });
                isLoggedOut = true;
            }
        });
        console.log(window.felib.main.event.CLOSE);

        /*window.flow.addEventListener(window.felib.main.event.CLOSE, (event) => {
            console.log("LOGS: EVENT = CLOSE");
            if (!isLoggedOut) {
                showAppErrorsDialog({ msg: 'logOutMsg', formatMessage, authError, appInterval });
                isLoggedOut = true;
            }
        });
*/
        let appInterval = setInterval(() => {
            if (!window.flow.socket || (window.flow.socket && window.flow.socket.readyState !== 1)) {
                if (!isLoggedOut) {
                    console.log("LOGS: WEBSOCKET CLOSED!");
                    showAppErrorsDialog({ msg: "lostConnectionMsg", formatMessage, authError, appInterval });
                    isLoggedOut = true;
                }
            }
        }, 1000);
    }
}

export const CustomAuth = (props) => {
    if (isTdk()) return <Auth {...props} />
    return null;
}
